import React, { useContext } from 'react';
import { ImArrowRight } from 'react-icons/im';
import MyContext from '../../../../Uttis/MyContext';
import './SqlLoop.scss';

const SqlLoop = ({ course, title, data }) => {
  const { navigate } = useContext(MyContext);

  const handleNavigate = (sectionTitle) => {
    navigate(`/learning/${course}/${sectionTitle}`);
  };

  return (
    <div className="sql-bar">
      {data?.map((item) => (
        <li
          key={item.html_title}
          className={title === item.html_title ? 'active' : ''}
          onClick={() => handleNavigate(item.html_title)}
        >
          <span className="lesson-title">{item.coursename}</span>
          <ImArrowRight className="arrow-icon" />
        </li>
      ))}
    </div>
  );
};

export default SqlLoop;
